import React, { useEffect, useState } from 'react'
import { ToastContainer } from 'react-toastify'
import { Routes, Route, useNavigate, Navigate } from 'react-router-dom'
import { Config, IISMethods } from 'config/IISMethods'
import 'react-toastify/dist/ReactToastify.css' // for applaying style to toaster
import { store } from './index'
import { connect } from 'react-redux'
import useService from 'hooks/useService'
import useCongnito from 'hooks/useCongnito'
import LinkExpired from 'view/LinkExpired'
import BadRequest from 'view/BadRequest'
import ProtectedRoute from 'components/ProtectedRoute'
import ErrorMessageModal from 'view/Components/ErrorMessageModal'
import PageLoader from 'components/PageLoader'
import PackageJson from '../package.json'
import VerifyOTP from 'view/Unlockdoor/VerifyOTP'
import UnlockDoor from 'view/Unlockdoor/UnlockDoor'

const App = () => {
    const getCurrentState = () => store.getState()
    const { handleGrid, getStorageData, getURLData, addLoaders, hasExactlyOneLengthOne } = useService()
    const { API_Call } = useCongnito()
    const [dataLoaded, setDataLoaded] = useState(false)

    // Global ResizeObserver error handler
    useEffect(() => {
        const handleResizeObserverError = (e) => {
            if (e.message === 'ResizeObserver loop limit exceeded') {
                e.stopImmediatePropagation();
                console.warn('ResizeObserver loop limit exceeded - this is a known issue with RSuite components');
            }
        };

        window.addEventListener('error', handleResizeObserverError);

        return () => {
            window.removeEventListener('error', handleResizeObserverError);
        };
    }, []);

    const history = useNavigate()

    if (Config.getServermode() === 'dev') {
        window.addEventListener('beforeunload', function (event) {
            event.preventDefault();
            window.location.reload(false);
            event.returnValue = '';
            var confirmationMessage = 'Are you sure you want to leave this page?';
            event.returnValue = confirmationMessage;
            return confirmationMessage;
        })
    }

    useEffect(() => {
        IISMethods.setSocketConnection()
        let currentVersion = localStorage.getItem('V') || ''
        if (!currentVersion || currentVersion !== PackageJson.version) {
            localStorage.setItem('V', PackageJson.version);
        }
        let storageData = IISMethods.getLocalData('DigitalkeyData') || {}
        if (!Object.keys(storageData).length || !storageData?.[getURLData().defaultURL]) {
            storageData[getURLData().defaultURL] = {}
            IISMethods.setLocalData('DigitalkeyData', storageData)
        }
    }, []);

    useEffect(() => {
        (async () => {
            await addLoaders('pageload', 1)
            // await AuthenticateCognito()
            await getLinkDetails()
        })();
    }, []);

    // link open page redirection flow | SG 🍕🍔~ 2025-10-16 ~ 04:36 PM
    const getLinkDetails = async () => {
        let url = Config.Lambda_weburl + 'getlinkdetails'

        let payload = { shortid: getURLData().defaultURL }

        let { Result } = await API_Call('p', url, payload, {})
        let Status = Result.status
        let ResultData = Result.data

        if (Status === 200) {
            if (hasExactlyOneLengthOne(ResultData)) {
                let storageData = IISMethods.getLocalData('DigitalkeyData') || {}
                let isRoom = (ResultData.digitalkeydata?.roomnoid && ResultData.digitalkeydata?.roomnoid !== Config.dummyid) ? 1 : 0 // identify room | BR ⭐✨💫 ~ 2025-09-15 ~ 01:06 PM
                let isArea = (ResultData.digitalkeydata?.areaid && ResultData.digitalkeydata?.areaid !== Config.dummyid) ? 1 : 0 // identify area | BR ⭐✨💫 ~ 2025-09-15 ~ 01:06 PM
                let isOnlyOneTime = (((ResultData.digitalkeydata?.isonetimekey && ResultData.digitalkeydata?.reservationid === Config.dummyid) || ResultData.onetimekeydata?.length)) ? 1 : 0
                let isRoomCancelOrNoshow = (isRoom === 1 && (ResultData.reservationdata[0]?.iscancel === 1 || ResultData.reservationdata[0]?.noshow === 1))
                let isOnetimeKeyExpired = (ResultData.digitalkeydata?.isonetimekey === 1 && !ResultData?.onetimekeydata.length && !ResultData?.roomlockdata?.length)

                if (isRoomCancelOrNoshow || isOnetimeKeyExpired) {
                    history(`/${getURLData().defaultURL}/linkexpired`);
                    handleGrid(Config.ErrorMessages[isOnetimeKeyExpired ? 'linkexpired' : 'reservationnotfound'], 'modal', 'errormodal', 1)
                }
                else {
                    let pageName = '', isOtpVerified = 0, isOpen = 0, isStatusUpdated = 0

                    let guestDetails = ResultData.reservationdata[0]?.keyaccessguestdetails?.find(guest =>
                        `+${guest.countrycode}${guest.phoneno}` === (ResultData.digitalkeydata?.fullcontact)
                    )
                    if (isOnlyOneTime === 1) {
                        isOpen = ResultData.onetimekeydata[0]?.isopen
                    }
                    else if (isRoom === 1) {
                        isOpen = ResultData.digitalkeydata?.reservationid !== Config.dummyid || ResultData?.reservationdata?.length !== 0 ? guestDetails?.isopen : ResultData.onetimekeydata[0]?.isopen
                    }
                    else if (isArea === 1) {
                        isOpen = ResultData.areadashboarddata[0]?.isopen
                    }
                    // let allKeysEmpty = ['areadashboarddata', 'onetimekeydata'].every(key => !Object.keys(ResultData[key] || {}).length);
                    if ((isRoom === 1 && ((ResultData.reservationdata?.length && !ResultData.reservationdata[0]?.keyaccessguestdetails?.length) || (!ResultData.reservationdata?.length && !ResultData.onetimekeydata?.length)))) {
                        isOtpVerified = 0
                        pageName = 'linkexpired'
                        handleGrid(Config.ErrorMessages['reservationnotfound'], 'modal', 'errormodal', 1)
                    }
                    else if (isOpen === 0 || getStorageData('isOtpVerified') === 1) {
                        isOtpVerified = 1
                        pageName = 'unlockdoor'
                    }
                    else if (isOpen === 1) {
                        if (ResultData.propertydata?.enablesharekey === 0) {
                            // pageName = (ResultData.digitalkeydata?.sendlink === 0 && getStorageData('isStatusUpdated') !== 1) ? 'linkexpired' : 'unlockdoor'
                            if (ResultData.digitalkeydata?.sendlink === 0 && getStorageData('isStatusUpdated') !== 1) {
                                pageName = 'linkexpired'
                                handleGrid(Config.ErrorMessages['accessdenied'], 'modal', 'errormodal', 1)
                            }
                            else pageName = 'unlockdoor'
                        }
                        else pageName = 'verifyotp'
                        isOtpVerified = 0
                    }

                    if (isOpen === 1) isStatusUpdated = 1
                    storageData[getURLData().defaultURL] = { ...ResultData, isStatusUpdated: isStatusUpdated, isOtpVerified: isOtpVerified }
                    IISMethods.setLocalData('DigitalkeyData', storageData)
                    history(`/${getURLData().defaultURL}/${pageName}`);
                }
            } 
            else if (ResultData?.areadashboarddata?.length === 0 && ResultData?.onetimekeydata?.length === 0 && ResultData?.reservationdata?.length === 0) {
                handleGrid(Config.ErrorMessages['reservationnotfound'], 'modal', 'errormodal', 1)
                history(`/${getURLData().defaultURL}/linkexpired`);
            }
            else {
                let storageData = IISMethods.getLocalData('DigitalkeyData') || {}
                let isRoom = (ResultData.digitalkeydata?.roomnoid && ResultData.digitalkeydata?.roomnoid !== Config.dummyid) ? 1 : 0 // identify room | BR ⭐✨💫 ~ 2025-09-15 ~ 01:06 PM
                let isArea = (ResultData.digitalkeydata?.areaid && ResultData.digitalkeydata?.areaid !== Config.dummyid) ? 1 : 0 // identify area | BR ⭐✨💫 ~ 2025-09-15 ~ 01:06 PM
                let isRoomCancelOrNoshow = (isRoom === 1 && Array.isArray(ResultData.reservationdata) && ResultData.reservationdata.length > 0
                    && ResultData.reservationdata.every(item => item.iscancel === 1 || item.noshow === 1));
                let isOnetimeKeyExpired = (ResultData.digitalkeydata?.isonetimekey === 1 && !ResultData?.onetimekeydata.length && !ResultData?.roomlockdata?.length)
                let fullContact = ResultData.digitalkeydata?.fullcontact;
                if (isRoomCancelOrNoshow || isOnetimeKeyExpired) {
                    history(`/${getURLData().defaultURL}/linkexpired`);
                    handleGrid(Config.ErrorMessages[isOnetimeKeyExpired ? 'linkexpired' : 'reservationnotfound'], 'modal', 'errormodal', 1)
                } else {
                    let pageName = '', isOtpVerified = 0, isOpen = 0, isStatusUpdated = 0, matchedDigitalKeys = []
                    let isblacklist = ResultData.reservationdata?.some(res =>
                        res?.keyaccessguestdetails?.some(guest =>
                            `+${guest.countrycode}${guest.phoneno}` === ResultData.digitalkeydata?.fullcontact &&
                            guest?.isblacklist === 1
                        )
                    );
                    if (isblacklist) {
                        // Add isblacklist: 1 to each group in roomlockdata
                        ResultData.roomlockdata = ResultData.roomlockdata?.map(group => ({
                            ...group,
                            isblacklist: 1
                        }));

                        // Add isblacklist: 1 to each group in arealockdata
                        ResultData.arealockdata = ResultData.arealockdata?.map(group => ({
                            ...group,
                            isblacklist: 1
                        }));

                    }
                    if (isRoom === 1 && ResultData.digitalkeydata?.reservationid !== Config.dummyid) {
                        let matchFound = ResultData.reservationdata?.some(res =>
                            res?.keyaccessguestdetails?.some(guest =>
                                `+${guest.countrycode}${guest.phoneno}` === ResultData.digitalkeydata?.fullcontact &&
                                guest?.isopen === 1
                            )
                        );

                        isOpen = matchFound ? 1 : 0;
                        // let's assume your input is ResultData.reservationdata
                    } 
                    else if (isArea === 1 && ResultData.digitalkeydata?.areaid !== Config.dummyid) {
                        let matchFound = ResultData.areadashboarddata?.some(res =>
                            `+${res.countrycode}${res.phoneno}` === ResultData.digitalkeydata?.fullcontact &&
                            res.isopen === 1
                        );
                        isOpen = matchFound ? 1 : 0;
                    }
                    else if (isRoom === 1 && ResultData.digitalkeydata?.reservationid === Config.dummyid && ResultData.digitalkeydata?.areaid === Config.dummyid && ResultData.digitalkeydata?.isonetimekey === 1) {
                        let matchFound = ResultData.onetimekeydata?.some(res =>
                            res.phoneno === fullContact &&
                            res.isopen === 1
                        );
                        isOpen = matchFound ? 1 : 0;
                    }
                    matchedDigitalKeys = [
                        ...(ResultData.reservationdata?.flatMap(res => res.keyaccessguestdetails || [])
                            .filter(guest => `+${guest.countrycode}${guest.phoneno}` === fullContact)
                            .map(guest => guest.digitalkey.split("/").slice(-3).join("/")) || []),

                        ...(ResultData.onetimekeydata?.map(guest =>
                            guest.digitalkey.split("/").slice(-3).join("/")
                        ) || []),

                        ...(ResultData.areadashboarddata?.map(guest =>
                            guest.digitalkey.split("/").slice(-3).join("/")
                        ) || [])
                    ];
                    if (isOpen === 0 || getStorageData('isOtpVerified') === 1) {
                        isOtpVerified = 1
                        pageName = 'unlockdoor'
                    } else if (isOpen === 1) {
                        if (ResultData.propertydata?.enablesharekey === 0) {
                            // pageName = (ResultData.digitalkeydata?.sendlink === 0 && getStorageData('isStatusUpdated') !== 1) ? 'linkexpired' : 'unlockdoor'
                            if (ResultData.digitalkeydata?.sendlink === 0 && getStorageData('isStatusUpdated') !== 1) {
                                pageName = 'linkexpired'
                                handleGrid(Config.ErrorMessages['accessdenied'], 'modal', 'errormodal', 1)
                            }
                            else pageName = 'unlockdoor'
                        }
                        else pageName = 'verifyotp'
                        isOtpVerified = 0
                    }
                    if (isOpen === 1) isStatusUpdated = 1
                    storageData[getURLData().defaultURL] = { ...ResultData, isStatusUpdated: isStatusUpdated, isOtpVerified: isOtpVerified }
                    matchedDigitalKeys?.forEach(keySuffix => {
                        storageData[keySuffix] = {
                            ...ResultData,
                            isStatusUpdated: isStatusUpdated,
                            isOtpVerified: isOtpVerified
                        };
                    });
                    IISMethods.setLocalData('DigitalkeyData', storageData)
                    history(`/${getURLData().defaultURL}/${pageName}`);
                }
            }
            await addLoaders('pageload', 0)
            setDataLoaded(true)
        }
        else {
            if (Status === 404) {
                handleGrid(Config.ErrorMessages['reservationnotfound'], 'modal', 'errormodal', 1)
            }
            history(`/${getURLData().defaultURL}/linkexpired`);
            await addLoaders('pageload', 0)
            setDataLoaded(true)
        }
    }

    const routesList = [
        { path: '/:pre/:cid/:ra/verifyotp', element: <VerifyOTP />, key: 'verifyotp', isProtected: false },
        { path: '/:pre/:cid/:ra/unlockdoor', element: <UnlockDoor />, key: 'unlockdoor', isProtected: false },
        { path: '/:pre/:cid/:ra/linkexpired', element: <LinkExpired />, key: 'linkexpired', isProtected: false },
    ]

    const routes = ({ path = '', element = <></>, isProtected = false, key = '' }) => {
        return <Route
            exact
            key={key}
            path={path}
            element={isProtected ? <ProtectedRoute mode={key}>{element}</ProtectedRoute> : element}
        />
    }

    IISMethods.setSocketConnection().once('digitalkeyrefresh', () => {
        window.location.reload();
    });

    return (
        <>
            <div className='container h-100'>
                <div className="inner-container h-100 bg-white">
                    {getCurrentState().loadings?.pageload === 1 && <PageLoader />}
                    {
                        (!getCurrentState().loadings?.pageload && dataLoaded) &&
                        <Routes>
                            {/* pre: Prefix, cid: Confirmation ID, ra: Room/Area | BR ⭐✨💫 ~ 2025-09-15 ~ 10:39 AM */}
                            {routesList.map((route) => routes(route))}
                            <Route path='/404' element={<BadRequest />} />
                            <Route path='*' element={<Navigate to='/404' />} />
                        </Routes>
                    }
                    <ErrorMessageModal
                        isOpen={getCurrentState().modal?.errormodal && typeof getCurrentState().modal?.errormodal === 'object'} // Use boolean flag
                        data={getCurrentState().modal?.errormodal} // { title: '', message: '' }
                        onClose={() => {
                            // Clear both the message and the open state
                            handleGrid(0, 'modal', 'errormodal', false);
                        }}
                        buttonText="OK"
                    />
                </div>
            </div>

            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={true}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </>
    )
}

const mapStateToProps = (state) => ({
    ...state,
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(App);